import { LeftOutlined } from '@ant-design/icons'
import { Button, Card, Col, Flex, Form, Input, Row } from 'antd'
import { useNavigate } from 'react-router-dom'

import { useQuestionnairesServiceCreateQuestionnaireEndpoint } from 'src/api/queries'
import { ApiError } from 'src/api/requests'
import { FormFooter, PageBreadcrumbs } from 'src/components'
import { useLocales } from 'src/locales'
import i18n from 'src/locales/i18n'
import { paths } from 'src/paths'
import { formErrorHandler } from 'src/utils'

export const CreateQuestionnaires = () => {
  const { t } = useLocales()
  const navigate = useNavigate()

  const [form] = Form.useForm()

  const { mutate } = useQuestionnairesServiceCreateQuestionnaireEndpoint({
    onSuccess: (data) => navigate(paths.questionnaires.edit(String(data?.id))),
    onError: (e: ApiError) => formErrorHandler(e.body.errors)
  })

  const onSubmit = async () => {
    const values = await form.validateFields()

    mutate({
      requestBody: {
        name: {
          ro: values.roTitle,
          ru: values.ruTitle
        },
        description: {
          ro: values.roTitle,
          ru: values.ruTitle
        }
      }
    })
  }

  const roTranslation = i18n.getFixedT('ro')(
    'questionnaires.questionnaire_title'
  )

  const ruTranslation = i18n.getFixedT('ru')(
    'questionnaires.questionnaire_title'
  )

  const roTranslationDesc = i18n.getFixedT('ro')(
    'questionnaires.questionnaire_desc'
  )

  const ruTranslationDesc = i18n.getFixedT('ru')(
    'questionnaires.questionnaire_desc'
  )

  return (
    <PageBreadcrumbs
      title={t('questionnaires.create_new_questionnaire')}
      items={[{ title: t('menu.questionnaires') }]}
    >
      <Flex vertical gap={24}>
        <Flex gap={16} justify="space-between">
          <Button
            icon={<LeftOutlined />}
            onClick={() => navigate(paths.questionnaires.root)}
          >
            {t('common.back')}
          </Button>
        </Flex>

        <Card>
          <Form form={form} requiredMark={false} layout="vertical">
            <Row gutter={[24, 24]}>
              <Col span={12}>
                <Form.Item label={roTranslation} name="roTitle">
                  <Input placeholder={roTranslation} suffix={<>RO</>} />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item label={ruTranslation} name="ruTitle">
                  <Input placeholder={ruTranslation} suffix={<>РУ</>} />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item label={roTranslationDesc} name="roDescription">
                  <Input.TextArea rows={3} placeholder={roTranslationDesc} />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item label={ruTranslationDesc} name="ruDescription">
                  <Input.TextArea rows={3} placeholder={ruTranslationDesc} />
                </Form.Item>
              </Col>
            </Row>

            <FormFooter
              onCancel={() => navigate(paths.questionnaires.root)}
              onSave={onSubmit}
            />
          </Form>
        </Card>
      </Flex>
    </PageBreadcrumbs>
  )
}
